export const px = (value: number) => {
  return `${value}px`
}

export const translate = (x: string, y: string) => {
  return `translate(${x}, ${y})`
}
